import { Controller } from "@hotwired/stimulus";
import { Modal } from "../utils/modal"

export default class extends Controller {
  static targets = ["predefined", "manual"]

  connect() {
    this.input()
  }

  input(event) {
    const isEmpty = !this.hasManualTarget || this.manualTarget.value.trim().length == 0

    this.predefinedTarget.classList.toggle("is-disabled", !isEmpty)
    this.predefinedTarget.readonly = !isEmpty

    // We cannot have no model even if overridden, so we set the model to
    // the first possible one.
    if (!isEmpty && this.predefinedTarget.options.selectedIndex === 0) {
      this.predefinedTarget.options.selectedIndex = 1
    }
  }
}
